import { ConfigServiceProvider } from '../config-service/config-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import { MapOfStringTo } from '../../../ranking/interfaces/utils';
import { StorageServiceProvider } from '../storage-service/storage-service';
import {PlayerServiceProvider} from "../player-service/player-service";

@Injectable()
export class DisplayServiceProvider {
  // todo: type screens, newBadges and newLevels
  private DEFAULT_TYPE: string = 'default';
  private screens: MapOfStringTo<any> = {};
  private screensType = this.DEFAULT_TYPE;
  private readonly screensUrl = '../../../../assets/screens.json';
  // newLevels and newBadges don't seem to be read at any point
  private newLevels = [];
  private newBadges = [];

  constructor(private configService: ConfigServiceProvider, private storageService: StorageServiceProvider, public http: HttpClient,
              private injector: Injector) {}

  public load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.getSource())
        .toPromise()
        .then((screens: MapOfStringTo<any>) => {
          this.screens = ENVIRONMENT.useLocalConfigs ? screens[this.screensType] : screens;
          return this.storageService.setObject('screens', this.screens);
        })
        .then(
          () => resolve(),
          (error) => reject(error),
        );
    });
  }

  private getSource(): string {
    if (ENVIRONMENT.useLocalConfigs) return this.screensUrl;
    return this.configService.getEngineUrl('screens');
  }

  // todo: type return value
  // TODO: wywalić screen
  // I don't understand why it is done this way. this.screens[this.screensType]['start'] and this.screens[this.screensType][screen]
  // don't seem to be used anywhere, but there's 20 calls to getScreenComponent with different values of 'screen'
  public getScreenComponent(screen: string, component: string) {
    if (!this.screens['start'] && !this.screens[screen]) {
      return null;
    }
    return this.screens[component];
  }

  public setScreenType(type: string) {
    this.screensType = type;
  }

  // maybe to remove
  public setNewLevels(levels) {
    this.newLevels = levels;
  }

  // maybe to remove
  public setNewBadges(badges) {
    this.newBadges = badges;
  }

  public getCurrentUserScreens(): any {
    return this.screens;
  }

  public getScreenByViewId(id: string): any {
    const playerService = this.injector.get(PlayerServiceProvider);
    const type = playerService.getType() || this.DEFAULT_TYPE;

    const userScreens = this.getCurrentUserScreens();
    if (!userScreens) {
      throw new Error(`Cannot find screen configs for type: '${type}'`);
    }

    const config = userScreens[id];
    if (!config) {
      throw new Error(`Cannot find a screen config for viewId: '${id}' in type screens: '${type}'`);
    }

    return config;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/display-service/display-service.ts